import angular from 'angular';
import RacedaysService from './racedays.service.js';
import RacedaySchema from './raceday.schema.js';

let racedayModule = angular.module('raceday', [])

    .service('RacedaysService', RacedaysService)
    .constant('RacedaySchema', RacedaySchema)
    .name;

export default racedayModule;
